<button
  class="btn btn-error btn-outline"
  (click)="characterImporter.click()"
  appAnalyticsClick="Savefile:Import"
  appSfx="ui-click"
  [sfxTrigger]="['click', 'hover']"
>
  Import
</button>
<input
  type="file"
  #characterImporter
  class="hidden"
  accept=".rek"
  (change)="importSavefile($event)"
/>
